export const propsUpdated = (props, thisObj, nextObj, debug = '') => {
  const changed = {}
  const updated = props.some((prop) => {
    const thisProp = thisObj[prop]
    const nextProp = nextObj[prop]
    const propUpdated =
      typeof thisProp === 'object'
        ? JSON.stringify(thisProp) !== JSON.stringify(nextProp)
        : thisProp !== nextProp
    if (propUpdated && debug.length > 0) {
      changed[prop] = { thisProp, nextProp }
    }
    return propUpdated
  })
  if (debug.length > 0) {
    console.log(debug, updated, changed)
  }
  return updated
}

export const stateUpdated = propsUpdated

export const returnTrue = () => true
